import _typeof from "@babel/runtime/helpers/typeof";
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import { LIQUORICE } from '@bubble-ui/particle-design-versions';
export var __iconAccent = '__iconAccent';
export var __iconAccentHovered = '__iconAccentHovered';
export var __iconAccentPressed = '__iconAccentPressed';
export var __iconAccentOnBackground = '__iconAccentOnBackground';
export var __iconAccentOnBackgroundHovered = '__iconAccentOnBackgroundHovered';
export var __iconAccentOnBackgroundPressed = '__iconAccentOnBackgroundPressed';
export var __iconDefault = '__iconDefault';
export var __iconDefaultHovered = '__iconDefaultHovered';
export var __iconDefaultPressed = '__iconDefaultPressed';
export var __iconDisabled = '__iconDisabled';
export var __iconDisabledOnBackground = '__iconDisabledOnBackground';
export var __iconError = '__iconError';
export var __iconErrorHovered = '__iconErrorHovered';
export var __iconErrorPressed = '__iconErrorPressed';
export var __iconErrorThickFont = '__iconErrorThickFont';
export var __iconErrorThickFontHovered = '__iconErrorThickFontHovered';
export var __iconErrorThickFontPressed = '__iconErrorThickFontPressed';
export var __iconInverse = '__iconInverse';
export var __iconInverseDisabled = '__iconInverseDisabled';
export var __iconAccentDisabled = '__iconAccentDisabled';
export var __iconInverseHovered = '__iconInverseHovered';
export var __iconInversePressed = '__iconInversePressed';
export var __iconInverseOnBackground = '__iconInverseOnBackground';
export var __iconInverseOnBackgroundHovered = '__iconInverseOnBackgroundHovered';
export var __iconInverseOnBackgroundPressed = '__iconInverseOnBackgroundPressed';
export var __iconNeutral = '__iconNeutral';
export var __iconNeutralHovered = '__iconNeutralHovered';
export var __iconNeutralPressed = '__iconNeutralPressed';
export var __iconNeutralOnBackground = '__iconNeutralOnBackground';
export var __iconNeutralOnBackgroundHovered = '__iconNeutralOnBackgroundHovered';
export var __iconNeutralOnBackgroundPressed = '__iconNeutralOnBackgroundPressed';
export var __iconNeutralThickFont = '__iconNeutralThickFont';
export var __iconNeutralThickFontHovered = '__iconNeutralThickFontHovered';
export var __iconNeutralThickFontPressed = '__iconNeutralThickFontPressed';
export var __iconSuccess = '__iconSuccess';
export var __iconSuccessHovered = '__iconSuccessHovered';
export var __iconSuccessPressed = '__iconSuccessPressed';
export var __iconSuccessThickFont = '__iconSuccessThickFont';
export var __iconSuccessThickFontHovered = '__iconSuccessThickFontHovered';
export var __iconSuccessThickFontPressed = '__iconSuccessThickFontPressed';
export var __iconWarning = '__iconWarning';
export var __iconWarningHovered = '__iconWarningHovered';
export var __iconWarningPressed = '__iconWarningPressed';
export var __iconWarningThickFont = '__iconWarningThickFont';
export var __iconWarningThickFontHovered = '__iconWarningThickFontHovered';
export var __iconWarningThickFontPressed = '__iconWarningThickFontPressed';
export var BLACK = 'black';
export var HOVERED_BLACK = 'hoveredBlack';
export var PRESSED_BLACK = 'pressedBlack';
export var BLUE = 'blue';
export var DARK_GRAY = 'darkGray';
export var HOVERED_DARK_GRAY = 'hoveredDarkGray';
export var PRESSED_DARK_GRAY = 'pressedDarkGray';
export var GRAY = 'gray';
export var DISABLED = 'disabled';
export var DEFAULT = 'default';
export var NEUTRAL = 'neutral';
export var NEUTRAL_ON_BACKGROUND = 'neutral_on_background';
export var GREEN = 'green';
export var METADATA = 'metadata';
export var ORANGE = 'orange';
export var PINK = 'pink';
export var RED = 'red';
export var PRIMARY = 'primary';
export var PRIMARY_DISABLED = 'primaryDisabled';
export var SECONDARY = 'secondary';
export var HOVERED_SECONDARY = 'secondary_hover';
export var INVERSE = 'inverse';
export var INVERSE_DISABLED = 'inverseDisabled';
export var INVERSE_ON_BACKGROUND = 'inverse_on_background';
export var DISABLED_ON_BACKGROUND = 'disabled_on_background';
export var WHITE = 'white';
export var WHITE_DISABLED = 'whiteDisabled';
export var WHITE_HOVER = 'white_hover';
export var BRAND_COLOR_ONE = 'brandColorOne';
export var BRAND_COLOR_TWO = 'brandColorTwo';
export var BRAND_COLOR_THREE = 'brandColorThree';
export var BRAND_COLOR_FOUR = 'brandColorFour';
export var BRAND_COLOR_FIVE = 'brandColorFive';
export var BRAND_COLOR_SIX = 'brandColorSix';
export var BRAND_COLOR_SEVEN = 'brandColorSeven';
export var mapColor = function mapColor(color, defaultColor) {
  var designVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : LIQUORICE;

  if (!color) {
    return defaultColor;
  } // hacky test if color is of type Color


  if (_typeof(color) === 'object' && typeof color.toRGBA === 'function') {
    return color.toRGBA();
  }

  switch (color) {
    case NEUTRAL:
    case GRAY:
    case METADATA:
    case __iconNeutral:
      return Colors.__iconNeutral(designVersion).toString();

    case BLACK:
    case DEFAULT:
    case __iconDefault:
      return Colors.__iconDefault(designVersion).toString();

    case BLUE:
    case SECONDARY:
    case __iconAccent:
      return Colors.__iconAccent(designVersion).toString();

    case NEUTRAL_ON_BACKGROUND:
    case DARK_GRAY:
    case __iconNeutralOnBackground:
      return Colors.__iconNeutralOnBackground(designVersion).toString();

    case __iconNeutralOnBackgroundHovered:
      return Colors.__iconNeutralOnBackgroundHovered(designVersion).toString();

    case __iconNeutralOnBackgroundPressed:
      return Colors.__iconNeutralOnBackgroundPressed(designVersion).toString();

    case __iconNeutralThickFont:
      return Colors.__iconNeutralThickFont(designVersion).toString();

    case __iconNeutralThickFontHovered:
      return Colors.__iconNeutralThickFontHovered(designVersion).toString();

    case __iconNeutralThickFontPressed:
      return Colors.__iconNeutralThickFontPressed(designVersion).toString();

    case DISABLED:
    case __iconDisabled:
      return Colors.__iconDisabled(designVersion).toString();

    case GREEN:
    case __iconSuccess:
      return Colors.__iconSuccess(designVersion).toString();

    case __iconSuccessHovered:
      return Colors.__iconSuccessHovered(designVersion).toString();

    case __iconSuccessPressed:
      return Colors.__iconSuccessPressed(designVersion).toString();

    case __iconSuccessThickFont:
      return Colors.__iconSuccessThickFont(designVersion).toString();

    case __iconSuccessThickFontHovered:
      return Colors.__iconSuccessThickFontHovered(designVersion).toString();

    case __iconSuccessThickFontPressed:
      return Colors.__iconSuccessThickFontPressed(designVersion).toString();

    case ORANGE:
    case __iconWarning:
      return Colors.__iconWarning(designVersion).toString();

    case __iconWarningHovered:
      return Colors.__iconWarningHovered(designVersion).toString();

    case __iconWarningPressed:
      return Colors.__iconWarningPressed(designVersion).toString();

    case __iconWarningThickFont:
      return Colors.__iconWarningThickFont(designVersion).toString();

    case __iconWarningThickFontHovered:
      return Colors.__iconWarningThickFontHovered(designVersion).toString();

    case __iconWarningThickFontPressed:
      return Colors.__iconWarningThickFontPressed(designVersion).toString();

    case RED:
    case __iconError:
      return Colors.__iconError(designVersion).toString();

    case __iconErrorHovered:
      return Colors.__iconErrorHovered(designVersion).toString();

    case __iconErrorPressed:
      return Colors.__iconErrorPressed(designVersion).toString();

    case __iconErrorThickFont:
      return Colors.__iconErrorThickFont(designVersion).toString();

    case __iconErrorThickFontHovered:
      return Colors.__iconErrorThickFontHovered(designVersion).toString();

    case __iconErrorThickFontPressed:
      return Colors.__iconErrorThickFontPressed(designVersion).toString();

    case PINK:
    case PRIMARY:
      return '#EB6F93';

    case PRIMARY_DISABLED:
      return 'rgba(235, 111, 147, 0.4)';

    case HOVERED_SECONDARY:
    case __iconAccentHovered:
      return Colors.__iconAccentHovered(designVersion).toString();

    case __iconAccentPressed:
      return Colors.__iconAccentPressed(designVersion).toString();

    case __iconAccentOnBackground:
      return Colors.__iconAccentOnBackground(designVersion).toString();

    case __iconAccentOnBackgroundHovered:
      return Colors.__iconAccentOnBackgroundHovered(designVersion).toString();

    case __iconAccentOnBackgroundPressed:
      return Colors.__iconAccentOnBackgroundPressed(designVersion).toString();

    case HOVERED_BLACK:
    case __iconDefaultHovered:
      return Colors.__iconDefaultHovered(designVersion).toString();

    case PRESSED_BLACK:
    case __iconDefaultPressed:
      return Colors.__iconDefaultPressed(designVersion).toString();

    case HOVERED_DARK_GRAY:
    case __iconNeutralHovered:
      return Colors.__iconNeutralHovered(designVersion).toString();

    case PRESSED_DARK_GRAY:
    case __iconNeutralPressed:
      return Colors.__iconNeutralPressed(designVersion).toString();

    case WHITE:
    case INVERSE:
    case __iconInverse:
      return Colors.__iconInverse(designVersion).toString();

    case WHITE_DISABLED:
    case INVERSE_DISABLED:
    case __iconInverseDisabled:
      return Colors.__iconInverseDisabled(designVersion).toString();

    case __iconAccentDisabled:
      return Colors.__iconAccentDisabled(designVersion).toString();

    case WHITE_HOVER:
    case __iconInverseHovered:
      return Colors.__iconInverseHovered(designVersion).toString();

    case __iconInversePressed:
      return Colors.__iconInversePressed(designVersion).toString();

    case INVERSE_ON_BACKGROUND:
    case __iconInverseOnBackground:
      return Colors.__iconInverseOnBackground(designVersion).toString();

    case __iconInverseOnBackgroundHovered:
      return Colors.__iconInverseOnBackgroundHovered(designVersion).toString();

    case __iconInverseOnBackgroundPressed:
      return Colors.__iconInverseOnBackgroundPressed(designVersion).toString();

    case DISABLED_ON_BACKGROUND:
    case __iconDisabledOnBackground:
      return Colors.__iconDisabledOnBackground(designVersion).toString();

    case BRAND_COLOR_ONE:
      return '#5C4144';

    case BRAND_COLOR_TWO:
      return '#564242';

    case BRAND_COLOR_THREE:
      return '#51444E';

    case BRAND_COLOR_FOUR:
      return '#424C4A';

    case BRAND_COLOR_FIVE:
      return '#3F443E';

    case BRAND_COLOR_SIX:
      return '#40494C';

    case BRAND_COLOR_SEVEN:
      return '#3D4336';

    default:
      return defaultColor;
  }
};
//# sourceMappingURL=index.js.map